<template>
  <div class="hotline_container">
    <hotline-modal v-if="show_modal" @cancel="toggle_modal($event)" @success="aftersuccess" :dataToSend="modal_data"></hotline-modal>
    <notifications v-if="any_errors || anyError" :error="errors"></notifications>
    <div class="hotline_head">
      <h4>Messages</h4>
      <button class="btn btn-success add-hotline-message" v-if="!addition_state && (haveHotline || origin == null)" @click="toggle_addition(true)">Creer</button>
      <button class="btn btn-default add-hotline-message" v-else-if="addition_state && (haveHotline || origin== null)" @click="toggle_addition(false)">Annuler</button>
    </div>
    <div class="creation_form" v-if="addition_state" >
      <hotline-form @toggle-modal="toggle_modal($event)" :origin="origin">
      </hotline-form>
    </div>
    <div class="hotline_messages_container" v-else>
      <div v-if="messages.hasOwnProperty('data') &&  messages.data.length > 0">
        <pagination v-if="paginationNeeded"
                    :current-page="currentPage"
                    :total-pages="totalPages" @click="getPageOnClick">
        </pagination>
        <div class="results col-md-12">
          <div>
            <div class="col-md-3">
              <h4>Emetteur</h4>
            </div>
            <div :class="head_style">
              <h4>Message</h4>
            </div>
            <div v-if="!origin" class="col-md-3">
              <h4>Destinataire</h4>
            </div>
          </div>
          <br>
          <div v-for="(message, idx) in messages.data" :key="'message-' + idx">
            <hotline-item :message="message" :origin="origin"></hotline-item>
          </div>
        </div>
        <pagination v-if="paginationNeeded"
                    :current-page="currentPage"
                    :total-pages="totalPages" @click="getPageOnClick">
        </pagination>
      </div>

      <div v-else>
        <hr>
        
        <div class="alert alert-info">
            <i class="fa fa-info-circle"></i> Aucun message n'a encore été ajouté pour ce client
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex"
import HotlineForm from "components/Customer/HotlineContent/HotlineForm"
import HotlineModal from "components/Hotline/Modal"
import HotlineItem from "components/Hotline/Item"
import Notifications from "components/Hotline/Notifications"
import Pagination from "components/Pagination"

export default {
  name:"Hotline_Message_list",
  components:{
    Pagination,
    HotlineForm,
    HotlineModal,
    Notifications,
    HotlineItem
  },

  props:["origin"],

  data(){
    return {
      addition_state:false,
      show_modal:false,
      modal_data:null,

    }
  },

  computed:{
    ...mapGetters("hotline", ["messages","any_errors", "errors"]),
    ...mapGetters(["anyError"]),
    ...mapState(["customer"]),

    paginationNeeded () {
      return this.messages.last_page > 1
    },

    totalPages() {
      return this.messages.last_page
    },

    currentPage(){
      return this.messages.current_page - 1
    },

    head_style(){
      return this.origin ? "col-md-9" : "col-md-6"
    },

    haveHotline() {
      var res = false
      if (this.customer)
        {
          _.each(this.customer.contracts, (ctc) => {
            if (ctc.contract_options.length > 0 && ctc.terminated == false)
              _.each(ctc.contract_options, cto => {
                if (cto.status == "active" && cto.option && cto.option.simple_hotline)
                  res = true
              })
          })
        }
      return res
    },
  },

  methods:{
    ...mapActions("hotline", ["fetch_all_hotline_messages","reset_datas","set_fetching_state","reset_hotline_errors","reset_errors","reset_customers"]),

    getPageOnClick(event){
      if (event + 1 <= this.totalPages)
      {
        var params = {page:event + 1}
        if (this.origin)
          params = _.assign(params, {customer_id:this.origin})
        this.set_fetching_state(true)
        this.fetch_all_hotline_messages(params)
            .then(() => this.set_fetching_state(false))
      }
    },

    toggle_addition(flag)
    {
      if (flag)
      {
        this.reset_customers()
        this.addition_state = true
      }
      else {
        this.addition_state = false
      }
    },

    toggle_modal(event)
    {
      if (event)
      {
        this.show_modal = true
        this.modal_data = event
        if (this.origin && this.customer)
          this.modal_data.related_customer = this.customer.profile
      }
      else {
        this.show_modal = false
        if (!this.anyError)
          this.modal_data = null
      }
    },

    aftersuccess()
    {
      this.toggle_modal(false)
      if (!this.anyError)
          this.toggle_addition(false)
      var params = {}
      if (this.origin)
          _.assign(params, {customer_id:this.origin})
      this.set_fetching_state(true)
      this.fetch_all_hotline_messages(params)
          .then(() => this.set_fetching_state(false))
      this.reset_datas()
    },
  },

  mounted(){
    this.set_fetching_state(true)
    var params = {}
    if (this.origin)
      _.assign(params, {customer_id:this.origin})
    this.fetch_all_hotline_messages(params)
        .then(() => this.set_fetching_state(false))
  }
}
</script>
<style scoped>

.hotline_container {
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
}

.hotline_head {
  display: flex;
  align-items: center;

}

.hotline_messages_container {

}

.add-hotline-message {
  margin-left: auto;
  height: 37px;
}


</style>



// WEBPACK FOOTER //
// client/components/Hotline/List.vue